import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RoomService } from '../../../../../core/services/room.service';
import { TemplateService } from '../../../../../core/services/template.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { AngularEditorModule } from '@kolkov/angular-editor';

@Component({
    selector: 'app-template',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule, AngularEditorModule],
    templateUrl: './template.component.html',
    styleUrls: ['./template.component.css']
})
export class TemplateComponent {
  buttonsPermission :any|undefined;
  search_text=""
   structures:any[] =[]
   roles:any[] =[]
   data:any[] =[]
   selected_data:any;
   modalOption:any; 
   isDtInitialized:boolean = false
   is_active=null
   loading=false
   tag="admin-templates"
   pg={
     pageSize:10,
     p:0,
     total:0
   }
   role:any
   user:any
 
 
   constructor(
     private templateService:TemplateService,
     private toastrService:ToastrService,
       config: NgbModalConfig,
       private lsService:LocalStorageService,
     private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      }
 
 
   ngOnInit(): void {
     this.init()
 this.getActions()
   }
 
   init(){
     this.getAll()
   
   }
 
  
 
   getAll(){
     this.templateService.getAll().subscribe((res:any)=>{
       this.data=res.data
       this.pg.p=0
       this.pg.total=res.data.length
       this.modalService.dismissAll()
     },
     (err:any)=>{
      AppErrorShow.showError("Gestion des types de livrable",err)

     })
   }
 
 
   store(value:any){
     this.loading=true
     
     this.templateService.store(value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
 
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des types de livrable",err)

     })
   }
   update(value:any){
     this.loading=true
 
     this.templateService.update(this.selected_data.id,value).subscribe((res:any)=>{
       this.loading=false
 
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       this.loading=false
 
       console.log(err)
         AppErrorShow.showError("Gestion des types de livrable",err)

     })
   }
   delete(){
     if(!this.verifyIfElementChecked()) return ;
     let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
     confirmed.then((result:any)=>{
        if (result.isConfirmed) {
     this.templateService.delete(this.selected_data.id).subscribe((res:any)=>{
         this.toastrService.success(res.message)
         this.getAll()
     },
     (err:any)=>{
       console.log(err)
         AppErrorShow.showError("Gestion des types de livrable",err)

     })
   }
 })
   }
   checked(el?:any){
     this.selected_data=el;
     this.is_active=el.is_active
   }
   verifyIfElementChecked(){
     console.log(this.selected_data)
     if (this.selected_data==null) {
       this.toastrService.warning("Aucun élément selectionné");
       return false;
     }
     return true;
   }
 
 
 
   dismiss(){
     this.modalService.dismissAll()
   }
 
   add(content:any){
     this.modalService.open(content,{size:'lg'});
   }
 
 
   show(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalOption={centered:false,size:"lg"}
     this.modalService.open(content,{size:'lg'});
   }
 
   edit(content:any){
     if(!this.verifyIfElementChecked()) return ;
     this.modalService.open(content,{size:'lg'});
 
   }
 
   setStatus(value:any){
 
     this.toastrService.warning("Opération en cours")
   
         this.templateService.setState(this.selected_data.id,value).subscribe((res:any)=>{
           this.toastrService.success(res.message)
           this.getAll()
       },
       (err:any)=>{
         console.log(err)
           AppErrorShow.showError("Gestion des types de livrable",err)

       })
   }
 
   getPage(event:any){
     this.pg.p=event
   }
 
   getActions(){
     // this.buttonsPermission = {
     //   show:AppActionCheck.check(this.tag,'Consultation'),
     //   add:AppActionCheck.check(this.tag,'ajout'),
     //   edit:AppActionCheck.check(this.tag,'edition'),
     //   delete:AppActionCheck.check(this.tag,'suppression'),
     //   status:AppActionCheck.check(this.tag,'statut')
     // };
     this.buttonsPermission={
       show:true,
       add:true,
       edit:true,
       delete:true,
       status:true,
     }
   }
}
